import { render, staticRenderFns } from "./Romanza_dessert.vue?vue&type=template&id=eb1f5eda&scoped=true"
import script from "./Romanza_dessert.vue?vue&type=script&lang=ts"
export * from "./Romanza_dessert.vue?vue&type=script&lang=ts"
import style0 from "./Romanza_dessert.vue?vue&type=style&index=0&id=eb1f5eda&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb1f5eda",
  null
  
)

export default component.exports